//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
export default {
  name: 'UpdateManage',
  data() {
    return {
      onUpdate: false,
      updateMessage: '',
      oldData: null,
    };
  },
  computed: {
    ...mapGetters('user', ['getElementList']),
    jurisdiction() {
      const jurisdictionArray = ['updateManage_releaseManagement_update'];
      const jurisdictionObj = {};
      for (const item of jurisdictionArray) {
        jurisdictionObj[item] = this.getElementList.includes(item);
      }

      return jurisdictionObj;
    },
  },
  mounted() {
    const cb = (data) => {
      console.log(data);
      this.onUpdate = data.status === 2;
      this.updateMessage = data.tips;
      this.oldData = data;
    };
    this.$request({ url: this.$api.getUpdateInfo, data: {}, cb });
  },
  methods: {
    confirm() {
      console.log(this.onUpdate, this.updateMessage);
      if (this.updateMessage === '') {
        this.$message.error('配置文字信息不能为空');
        return;
      }
      const cb = () => {
        this.$message.success('修改成功');
      };
      this.$request({
        url: this.$api.setUpdateInfo,
        data: {
          status: this.onUpdate ? 2 : 1,
          tips: this.updateMessage,
        },
        cb,
      });
    },
    cancel() {
      this.onUpdate = this.oldData.status === 2;
      this.updateMessage = this.oldData.tips;
    },
  },
};
